import { Badge } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

export const SupplierBadges: FC<{
  suppliers: { name: string; id: string }[];
}> = ({ suppliers }) => {
  const maxSuppliersToShow = 2;
  const suppliersToShow = suppliers.slice(0, maxSuppliersToShow);
  const remainingSuppliers = suppliers.length - maxSuppliersToShow;
  return (
    <span className="inline-flex gap-x-1">
      {suppliersToShow.map((supplier) => (
        <Badge key={supplier.id} variant="soft">
          <UntitledIcon name="truck-01.3" className="size-3.5" />
          {supplier.name}
        </Badge>
      ))}
      {remainingSuppliers > 0 && (
        <Badge variant="soft">+{remainingSuppliers}</Badge>
      )}
    </span>
  );
};
